import { Directive, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Directive()
export abstract class Unsubscribable implements OnDestroy {
	protected unsubSubj: Subject<void> = new Subject<void>();
	protected unsub: Observable<void> = this.unsubSubj.asObservable();

	unsubDestroy() {
		this.unsubSubj.next();
		this.unsubSubj.complete();
	}

	ngOnDestroy() {
		this.unsubDestroy();
	}
}
